export default function() {
  const widgetName = 'fairCalendar';
  const widgetOpts = fairCalendarOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'MORE'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      console.log(data)
      if (!hasData) {
        $('.fair-homepage .tier-two').hide();
      }

      $(`#${widgetName} .card-widget-item`).each(function(i, item) {
        // Format date + create element
        if (data.items[i].DateRange) {
          const rawDate = data.items[i].DateRange;
          const month = rawDate.slice(0,3);
          const day = rawDate.slice(4,7).replace(',','');
          const year = rawDate.slice(-4);

          $(this).prepend(`
            <div class="card-widget-date">
              <span class="date-month">${month}</span>
              <span class="date-day">${day}</span>
              <spanc class="date-year">${year}</span>
            </div>
          `);
        }
        
        // Place description element
        const description = $(this).find('.card-widget-description');
        const imageContainer = $(this).find('.image-container');
        description.appendTo(imageContainer);

        // Button stuff
        const buttonwrap = $(this).find('.buttonwrap');
        const buyNowButton = $(this).find('.buyNowButton');
        // const moreButton = $(this).find('.moreButton');
        buyNowButton.addClass('button');
        // moreButton.addClass('button');

        let purchaseURL = data.items[i].PurchaseURL;
        const URL = data.items[i].URL;

        if (purchaseURL === null) {
          let purchaseURL = URL;
          buttonwrap.prepend(`<a class="button buyNowButton" href=${purchaseURL}>MORE</a>`);
        }

        if (!purchaseURL && !URL) {
          buttonwrap.hide();
        }

        // Limit # of characters in title
        const title = $(this).find('.card-widget-title');
        const titleText = title.text();
        const titleCharacterLimit = 50;

        if (titleText.length > titleCharacterLimit) {
          const trimmedText = titleText.substring(0, titleCharacterLimit);
          title.text(trimmedText + '...');
        }

        // // Limit # of characters in description & hide description if empty
        const descriptionText = description.text();
        const descCharacterLimit = 180;

        if (descriptionText.length === 0) {
          description.hide();
        }

        if (descriptionText.length > descCharacterLimit) {
          const trimmedText = descriptionText.substring(0, descCharacterLimit);
          description.text(trimmedText + '...');
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE >'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false,
    textOverImage: false
  });

}